<template>
  <div class="team-card" :class="{highlighted: highlighted}" ref="card">
    <div class="team-card-avatar">
      <img :src="avatar" alt="avatar"/>
    </div>
    <h3 class="team-card-name">{{name}}</h3>
    <div class="team-card-title" v-html="title"></div>
    <div class="team-card-qualification" v-html="qualification"></div>
    <slide-toggle :expanded="isExpand">
      <div class="team-card-text" v-html="info"></div>
    </slide-toggle>
    <div
      class="team-card-trigger"
      v-if="info"
      @click="onExpand()"
      :class="{active: isExpand}"
    ><b-icon icon="chevron-down"></b-icon></div>
  </div>
</template>
<script>
import SlideToggle from "@/components/functional/SlideToggle"
export default {
  name: "team-card",
  props: {
    id: String,
    name: String,
    avatar: String,
    title: String,
    info: String,
    qualification: String,
    highlighted: Boolean
  },
  data() {
    return {
      isExpand: false
    };
  },
  methods: {
    onExpand() {
      this.isExpand = !this.isExpand;
      if (this.isExpand) {
        setTimeout(() => {
          this.$refs.card.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        }, 200);
      } else {
        this.$emit("collapse");
      }
    }
  },
  components: {
    SlideToggle
  }
}
</script>
